// extracted by mini-css-extract-plugin
export default {"round":"components_round__Gp3Rx"};